export default [
    {
        path: 'formula-exame',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-formula-exame' */
            '@/views/exame-laboratorial/formula-exame/Index'
        ),
        redirect: 'formula-exame/index',
        children: [
            {
                name: 'exame-laboratorial-formula-exame-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-formula-exame' */
                    '@/views/exame-laboratorial/formula-exame/List.vue'
                ),
            },
            {
                name: 'exame-laboratorial-formula-exame-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-formula-exame' */
                    '@/views/exame-laboratorial/formula-exame/Form.vue'
                ),
            },
            {
                name: 'exame-laboratorial-formula-exame-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-formula-exame' */
                    '@/views/exame-laboratorial/formula-exame/Form.vue'
                ),
            },
        ],
    }
]